<template>
  <div class="container">
    <div class="d-flex flex-column justify-content-center align-items-center" id="main">
      <div class="d-flex align-items-center">
        <h1 class="mr-3 pr-3 align-top border-right inline-block align-content-center"><i class="fas fa-qrcode"></i></h1>
        <div class="inline-block align-middle">
          <h2 class="font-weight-normal lead" id="desc">QRCode expirado</h2>
        </div>
      </div>
      <a v-if="redirectUrl" :href="redirectUrl" class="btn btn-primary btn-lg mt-4">
        Gerar novo QRCode Pix
      </a>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['config'],
  computed: {
    redirectUrl () {
      const template = this.config && this.config.expiredRedirectUrl
      if (!template) return null
      const amount = (this.$route.params && this.$route.params.rawAmount) != null
        ? this.$route.params.rawAmount
        : 2000
      return template.replace('{{amount}}', amount)
    }
  }
}
</script>

<style lang="scss">

#main {
    height: 90vh;
}

#desc {
  font-size: 1.50rem;
}

</style>
